
/** Utility functions for interaction with html components */
export class HtmlUtils
{
    public static HexToRgbColorString(hexColor: string) {
        const colorString = hexColor.substring(1);
        const rgbArr = colorString.match(/.{1,2}/g)
            .map(function(hex) { return parseInt(hex, 16) });
        return rgbArr.join();
    }

    public static HexToInt(hexColor: string): number {
        const colorString = hexColor.substring(1);
        return ~parseInt(colorString, 16)^0x00FFFFFF;
    }

    public static IntToHex(number: number): string {
        return '#' + (number & 0x00FFFFFF).toString(16).padStart(6, '0');
    }
}
